import { createElement, cloneElement } from 'react';
import { puree } from '@ux/pure-enhance';
import { defaultProps, withProps } from '@team-griffin/rehook';
import { useTheme } from '@ux/theme-utils';
import { ifElse, is } from 'ramda';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var TypefaceStyle;

(function (TypefaceStyle) {
  TypefaceStyle["CONTENT"] = "content";
  TypefaceStyle["DISPLAY"] = "display";
})(TypefaceStyle || (TypefaceStyle = {}));

var enhance = puree('Typeface')(defaultProps({
  component: 'span'
}), withProps(function (props) {
  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  return {
    styles: Object.assign({
      fontFamily: theme.typography[props.face]
    }, props.style)
  };
}));

var PureTypeface = function PureTypeface(_a) {
  var component = _a.component,
      styles = _a.styles,
      face = _a.face,
      rest = __rest(_a, ["component", "styles", "face"]);

  var createElementByComponent = ifElse(is(String), function (component) {
    return createElement(component, Object.assign({}, rest, {
      style: styles
    }));
  }, function (component) {
    return cloneElement(component, {
      style: styles
    });
  });
  return createElementByComponent(component);
};

var Typeface = enhance(PureTypeface);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var enhance$1 = puree('Content')();

var PureContent = function PureContent(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return createElement(Typeface, _extends({}, props, {
    face: TypefaceStyle.CONTENT
  }), children);
};

var Content = enhance$1(PureContent);

var PureDisplay = function PureDisplay(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return createElement(Typeface, _extends({}, props, {
    face: TypefaceStyle.DISPLAY
  }), children);
};

var enhance$2 = puree('Display')();
var Display = enhance$2(PureDisplay);

export { Content, Display, Typeface, TypefaceStyle };
